import React, { useState } from 'react';
import { Layout, Button, Typography, theme, Grid } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useAuthContext } from '../contexts/AuthContext';
import ErrorBanner from '../../features/errors/ErrorBanner';
import ErrorNotification from '../../features/errors/ErrorNotification';

const { Header, Content } = Layout;
const { Text } = Typography;
const { useBreakpoint } = Grid;

const AppLayout: React.FC = () => {
  const { user, role } = useAuthContext();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { token } = theme.useToken();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const toggleSidebar = () => setSidebarCollapsed(!sidebarCollapsed);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar
        collapsed={isMobile ? sidebarCollapsed : false}
        isMobile={isMobile}
        onClose={() => setSidebarCollapsed(true)}
      />
      <Layout>
        <Header
          style={{
            padding: '0 16px',
            background: token.colorBgContainer,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            {isMobile && (
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={toggleSidebar}
                style={{ fontSize: '20px' }}
              />
            )}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {!isMobile && (
                <>
                  <Text strong>{user}</Text>
                  <Text type="secondary">({role === 'superadmin' ? 'Administrator' : 'User'})</Text>
                </>
              )}
            </div>
          </div>
        </Header>
        <Content style={{ margin: isMobile ? '8px' : '16px' }}>
          <ErrorBanner />
          <div
            style={{
              padding: isMobile ? 12 : 24,
              minHeight: 'calc(100vh - 64px - 32px)',
              background: token.colorBgContainer,
              borderRadius: token.borderRadiusLG,
            }}
          >
            <Outlet />
          </div>
        </Content>
      </Layout>
      <ErrorNotification />
    </Layout>
  );
};

export default AppLayout;
